import { find, get } from "lodash";
import { airports } from "../assets/airportData";

export function findFlagCodeByCountryName(countryName: string) {
    const country = find(airports, c => c.country === countryName)
    return get(country, 'flag_code', '')
}